module.exports = __webpack_public_path__ + "img/concepts.91277372.png";